import axios from 'axios'

export default {
    namespaced: true,
    state: {
        systems: [],
        task_status: [],
        users: []
    },
    getters: {
        systems (state) {
            return state.systems
        },
        task_status (state) {
            return state.task_status
        },
        users (state) {
            return state.users
        }
    },
    mutations: {
        SET_SYSTEMS(state, payload) {
            state.systems = payload
        },
        SET_TASK_STATUS(state, payload) {
            return state.task_status = payload
        },
        SET_USERS(state, payload) {
            state.users = payload
        }
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.get('data')
            commit('SET_SYSTEMS', response.data.systems)   
            commit('SET_TASK_STATUS', response.data.task_status) 
            commit('SET_USERS', response.data.users)
        },
        async addTask( { dispatch }, data) {
            let response = await axios.post('tasks', data)
            await dispatch('getData')
            return response.data
        },
        async updateTask( { dispatch }, data) {
            let response = await axios.put('tasks/' + data.id , data)
            await dispatch('getData')
            return response.data
        },
        async addTaskComment(_, data) {
            let response = await axios.post('comments/task', data)        
            return response.data
        },
    }
}